<template>
  <div class="Pannel5">
    <NavTiltle :titleNav="title" :titleTextNav="titleText" />
    <!-- PC -->
    <div class="pc-conent">
      <!-- <div class="small-box" v-for="val in techAdvances" :key="val.id">
        <div class="showImg"><img :src="val.path" alt="advimg" /></div>
        <tabCard :items="val.nameList" style="" class="showTabcard" />
      </div> -->
      <div
        v-for="(item, index) in techAdvances"
        :key="index"
        :class="item.isxains == '1' ? 'tap' : 'tap1'"
      >
        <div class="left" v-if="item.isxains != 1" @mouseover="quehuan(index)">
          <img :src="item.poster" alt="" />
          <!-- <video
             :poster="item.poster"
             autoplay="autoplay"
             id="pcVideo"
             :src="item.path"
             loop="loop"
             muted="muted"
             x5-video-player-type="h5"
             playsinline
             webkit-playsinline
             controlsList="nodownload"
             height="100%"
             width="100%"
             class="videopostar"
             style=" object-fit:fill;"
             ref="videoPlayp5"
           ></video> -->
          <div class="mengc1">
            <div class="text-num">
              <span>{{ item.name }}</span>
              <p>[{{ item.nameList.length }}+]</p>
            </div>
          </div>
        </div>
        <div class="right" v-else>
          <div class="title">
            <div class="title-left">
               <!-- <img :src="imgs" alt="" /> -->
                <video
                   :poster="item.poster"
                   autoplay="autoplay"
                   id="pcVideo"
                   :src="imgs"
                   loop="loop"
                   muted="muted"
                   x5-video-player-type="h5"
                   playsinline
                   webkit-playsinline
                   controlsList="nodownload"
                   height="100%"
                   width="100%"
                   class="videopostar"
                   style=" object-fit:fill;"
                   ref="videoPlayp5"
                 ></video>
              <div class="mengc">
                <div class="text-num">
                  <span>{{ item.name }}</span>
                  <p>[{{ item.nameList.length }}+]</p>
                </div>
              </div>
            </div>
            <div class="title-right">
              <div
                v-for="(ite, inde) in item.nameList"
                :key="inde"
                :class="ite.isxian == '1' ? 'rights1' : 'rights'"
                @click="dianji(ite.isxian, index, inde)"
              >
                <div class="right-shang">
                  <div class="gang" v-if="ite.isxian == '0'"></div>
                  <div class="zi">
                    <span>{{ ite.name }}</span>
                  </div>
                </div>
                <div class="right-xia" v-if="ite.isxian == '1'">
                  {{ ite.dec }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- moblie  -->
    <div class="moblie-conent">
      <el-tabs @tab-click="handleClick">
        <el-tab-pane
          :label="item.name"
          v-for="(item, index) in techAdvances"
          :key="index"
        >
          <div class="right">
            <div class="title">
              <div class="title-left">
               <!-- -->
               <video
                  :id="'moblieVideo'+index"

                  :src="item.path"
                  loop="loop"
                  muted="muted"
                  x5-video-player-type="h5"
                  playsinline
                  webkit-playsinline
                  controlsList="nodownload"
                  height="100%"
                  width="100%"
                  class="videopostar"
                  style=" object-fit:fill;"
                  ref="videoPlayMoblie"
                >
                </video>
                 <img :src="item.poster" class="posImg" :style="{zIndex:posFlag?9:0}"  >
                 <span @click="posCKI(index)" class="spImg" :style="{zIndex:posFlag?9:0}" ></span>
                 </img>
                <!-- 占位图 -->
                   <!-- <el-image :src="item.path">
                        <div slot="placeholder" class="image-slot">
                                <img src="../assets/images/falipic.png" class="errimg" alt="" />
                         </div>
                       </el-image> -->
                <!-- <img :src="item.path" alt="" /> -->
                <div class="mengc">
                  <div class="text-num">
                    <span>{{ item.name }}</span>
                    <p>[{{ item.nameList.length }}+]</p>
                  </div>
                </div>
              </div>
              <div class="title-right">
                <div
                  v-for="(ite, inde) in item.nameList"
                  :key="inde"
                  :style="{
                    marginBottom: item.nameList.length == inde + 1 ? '0' : '10px',
                  }"
                  :class="ite.isxian == '1' ? 'rights1' : 'rights'"
                  @click.stop="dianji(ite.isxian, index, inde)"
                >
                  <div class="right-shang">
                    <div class="gang" v-if="ite.isxian == '0'"></div>
                    <div class="zi">
                      <span>{{ ite.name }}</span>
                    </div>
                  </div>
                  <div class="right-xia" v-if="ite.isxian == '1'">
                    {{ ite.dec }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--<tabCard
            :items="val.nameList"
            style="width: 100%;"
            class="showTabcard"
          /> -->
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import NavTiltle from "../components/NavTiltle.vue";
import tabCard from "../components/tabCard.vue";
export default {
  name: "Pannel5",
  data() {
    return {
      posFlag:true,
      imgs: require("./../assets/images/核心技术/AI/skin.png"),
      title: "核心技术",
      titleText: "CORE TECHNOLOGY",
      tabPosition: "left",
      activeName: "",
      techAdvances: [
        {
          name: "AI检测",
          poster:"https://cdn.meidaojia.com/mdjwebImages/image/Images-newmdj/skin.png",
          // poster:"https://cdn.meidaojia.com/mdjwebImages/image/%E6%A0%B8%E5%BF%83%E6%8A%80%E6%9C%AF/AI/skin.png",
          path:"https://cdn.meidaojia.com/mdjwebImages/video/ai_skin.mp4",
          id: 1,
          isxains: 1,
          nameList: [
            {
              name: "皮肤检测",
              poster:"https://cdn.meidaojia.com/mdjwebImages/image/Images-newmdj/skin.png",
              // poster:"https://cdn.meidaojia.com/mdjwebImages/image/%E6%A0%B8%E5%BF%83%E6%8A%80%E6%9C%AF/AI/skin.png",
              path:"https://cdn.meidaojia.com/mdjwebImages/video/ai_skin.mp4",
              id: 1,
              dec: "多维度智能测肤，包括皮肤的基本情况和皮肤多种问题及位置。",
              isxian: 1,
            },
            {
              name: "皮肤纹理分析",
              poster:"https://cdn.meidaojia.com/mdjwebImages/image/Images-newmdj/texture.png",
              // path:
              //   "https://cdn-mdj.oss-cn-beijing.aliyuncs.com/mdjwebImages/image/%E6%A0%B8%E5%BF%83%E6%8A%80%E6%9C%AF/AI/texture.png",
              // poster:"https://cdn.meidaojia.com/mdjwebImages/image/%E6%A0%B8%E5%BF%83%E6%8A%80%E6%9C%AF/AI/texture.png",
              path:"https://cdn.meidaojia.com/mdjwebImages/video/ai_texture.mp4",
              id: 2,
              dec: "精准识别皮肤细节纹理，和问题属性，比如，色斑的多种类型等。",
              isxian: 0,
            },
            {
              name: "人体技术",
              poster:"https://cdn.meidaojia.com/mdjwebImages/image/Images-newmdj/bodyi.png",
              // path:
              //   "https://cdn-mdj.oss-cn-beijing.aliyuncs.com/mdjwebImages/image/%E6%A0%B8%E5%BF%83%E6%8A%80%E6%9C%AF/AI/bodyi.jpg",
             // poster:"https://cdn.meidaojia.com/mdjwebImages/image/%E6%A0%B8%E5%BF%83%E6%8A%80%E6%9C%AF/AI/bodyi.jpg",
             path:"https://cdn.meidaojia.com/mdjwebImages/video/ai_bodyi.mp4",
              id: 3,
              dec:
                "神奇的2D转3D技术，图片输入，立体维度输出，如肩宽、臂围、臀围、腿围等身材数据。",
              isxian: 0,
            },
            {
              name: "五官分析",
              poster:"https://cdn.meidaojia.com/mdjwebImages/image/Images-newmdj/senses.png",
              // path:
                // "https://cdn-mdj.oss-cn-beijing.aliyuncs.com/mdjwebImages/image/%E6%A0%B8%E5%BF%83%E6%8A%80%E6%9C%AF/AI/senses.png",
              // poster:"https://cdn.meidaojia.com/mdjwebImages/image/%E6%A0%B8%E5%BF%83%E6%8A%80%E6%9C%AF/AI/senses.png",
              path:"https://cdn.meidaojia.com/mdjwebImages/video/ai_senses.mp4",
              id: 4,
              dec:
                "精细识别面部五官特征，内含超丰富多维度数据，包括眉毛、眼睛、脸型等五官类型和三庭五眼、黄金三角等面部区域比例。",
              isxian: 0,
            },
            {
              name: "健康检测",
              poster:"https://cdn.meidaojia.com/mdjwebImages/image/Images-newmdj/healthy.png",
              // path:
              //   "https://cdn-mdj.oss-cn-beijing.aliyuncs.com/mdjwebImages/image/%E6%A0%B8%E5%BF%83%E6%8A%80%E6%9C%AF/AI/healthy.png",
              // poster:"https://cdn.meidaojia.com/mdjwebImages/image/%E6%A0%B8%E5%BF%83%E6%8A%80%E6%9C%AF/AI/healthy.png",
              path:"https://cdn.meidaojia.com/mdjwebImages/video/ai_healthy.mp4",
              id: 5,
              dec: "传统中医面诊的识别与健康分析。",
              isxian: 0,
            },
            {
              name: "头发分析",
              poster:"https://cdn.meidaojia.com/mdjwebImages/image/Images-newmdj/Hairs.jpg",
              // path:
              //   "https://cdn-mdj.oss-cn-beijing.aliyuncs.com/mdjwebImages/image/%E6%A0%B8%E5%BF%83%E6%8A%80%E6%9C%AF/AI/Hairs.png",
              // poster:"https://cdn.meidaojia.com/mdjwebImages/image/%E6%A0%B8%E5%BF%83%E6%8A%80%E6%9C%AF/AI/Hairs.png",
              path:"https://cdn.meidaojia.com/mdjwebImages/video/ai_Hairs.mp4",
              id: 6,
              dec: "识别头发的多种问题，包含脱发和发际线等。",
              isxian: 0,
            },
          ],
        },
        {
          name: "3D技术",
          poster:"https://cdn.meidaojia.com/mdjwebImages/image/Images-newmdj/face.png",
         // path:"https://cdn-mdj.oss-cn-beijing.aliyuncs.com/mdjwebImages/image/%E6%A0%B8%E5%BF%83%E6%8A%80%E6%9C%AF/3D/face.jpg",
          // poster:"https://cdn.meidaojia.com/mdjwebImages/image/%E6%A0%B8%E5%BF%83%E6%8A%80%E6%9C%AF/3D/face.jpg",
          path:"https://cdn.meidaojia.com/mdjwebImages/video/3d_face.mp4",
          id: 2,
          isxains: 0,
          nameList: [
            {
              name: "3D人脸建模",
              poster:"https://cdn.meidaojia.com/mdjwebImages/image/Images-newmdj/face.png",
              // path:
              //   "https://cdn-mdj.oss-cn-beijing.aliyuncs.com/mdjwebImages/imWeChat_20200924194436.mp4age/%E6%A0%B8%E5%BF%83%E6%8A%80%E6%9C%AF/3D/face.jpg",
              // poster:"https://cdn.meidaojia.com/mdjwebImages/image/%E6%A0%B8%E5%BF%83%E6%8A%80%E6%9C%AF/3D/face.jpg",
              path:"https://cdn.meidaojia.com/mdjwebImages/video/3d_face.mp4",
              id: 1,
              dec: "3D人脸建模，人脸美化，表情，发型全部搞定",
              isxian: 1,
            },
            {
              name: "3D人体建模",
              poster:"https://cdn.meidaojia.com/mdjwebImages/image/Images-newmdj/peoplenew.png",
              // path:
              //   "https://cdn-mdj.oss-cn-beijing.aliyuncs.com/mdjwebImages/image/%E6%A0%B8%E5%BF%83%E6%8A%80%E6%9C%AF/3D/people.png",
              // poster:"https://cdn.meidaojia.com/mdjwebImages/image/%E6%A0%B8%E5%BF%83%E6%8A%80%E6%9C%AF/3D/people.png",
              path:"https://cdn.meidaojia.com/mdjwebImages/video/3d_peoplenew.mp4",
              id: 2,
              dec: "3D人体，300多个特征点识别和调整能力",
              isxian: 0,
            },
            {
              name: "3D虚拟主播",
              poster:"https://cdn.meidaojia.com/mdjwebImages/image/Images-newmdj/anchornew.png",
              // path:
              //   "https://cdn-mdj.oss-cn-beijing.aliyuncs.com/mdjwebImages/image/%E6%A0%B8%E5%BF%83%E6%8A%80%E6%9C%AF/3D/people.png",
              // poster:"https://cdn.meidaojia.com/mdjwebImages/image/%E6%A0%B8%E5%BF%83%E6%8A%80%E6%9C%AF/3D/face.jpg",
              path:"https://cdn.meidaojia.com/mdjwebImages/video/3d_anchornew.mp4",
              id: 3,
              dec: "基于3D人体建模，结合自然语言生成技术，将文本自动转换为视频，支持多种语言和方言。适用于直播和视频等线上场景。",
              isxian: 0,
            },
          ],
        },
        {
          name: "图像技术",
          poster:"https://cdn.meidaojia.com/mdjwebImages/image/Images-newmdj/clothing.png",
          // path:
          //   "https://cdn-mdj.oss-cn-beijing.aliyuncs.com/mdjwebImages/image/%E6%A0%B8%E5%BF%83%E6%8A%80%E6%9C%AF/%E5%9B%BE%E5%83%8F/clothing.png",
          // poster:"https://cdn.meidaojia.com/mdjwebImages/image/%E6%A0%B8%E5%BF%83%E6%8A%80%E6%9C%AF/%E5%9B%BE%E5%83%8F/clothing.png",
          path:"https://cdn.meidaojia.com/mdjwebImages/video/pic_clothing.mp4",
          id: 3,
          isxains: 0,
          nameList: [
            {
              name: "服装试穿",
              poster:"https://cdn.meidaojia.com/mdjwebImages/image/Images-newmdj/clothing.png",
              // path:
              //   "https://cdn-mdj.oss-cn-beijing.aliyuncs.com/mdjwebImages/image/%E6%A0%B8%E5%BF%83%E6%8A%80%E6%9C%AF/%E5%9B%BE%E5%83%8F/clothing.png",
              // poster:"https://cdn.meidaojia.com/mdjwebImages/image/%E6%A0%B8%E5%BF%83%E6%8A%80%E6%9C%AF/%E5%9B%BE%E5%83%8F/clothing.png",
              path:"https://cdn.meidaojia.com/mdjwebImages/video/pic_clothing.mp4",
              id: 1,
              dec: "在线虚拟服装试穿，真实还原用户身材和相貌",
              isxian: 1,
            },
         /*   {
              name: "眼镜试戴",
              poster:"https://cdn.meidaojia.com/mdjwebImages/image/Images-mdj/glassie.png",
              // path:
              //   "https://cdn-mdj.oss-cn-beijing.aliyuncs.com/mdjwebImages/image/%E6%A0%B8%E5%BF%83%E6%8A%80%E6%9C%AF/%E5%9B%BE%E5%83%8F/glassie.png",
              // poster:"https://cdn.meidaojia.com/mdjwebImages/image/%E6%A0%B8%E5%BF%83%E6%8A%80%E6%9C%AF/%E5%9B%BE%E5%83%8F/glassie.png",
              path:"https://cdn.meidaojia.com/mdjwebImages/video/pic_glassie.mp4",
              id: 2,
              dec: "框架眼镜、墨镜非建模方式的一键上脸",
              isxian: 0,
            }, */
            {
              name: "美妆美瞳",
              poster:"https://cdn.meidaojia.com/mdjwebImages/image/Images-newmdj/cosmetict.png",
              // path:
              //   "https://cdn-mdj.oss-cn-beijing.aliyuncs.com/mdjwebImages/image/%E6%A0%B8%E5%BF%83%E6%8A%80%E6%9C%AF/%E5%9B%BE%E5%83%8F/cosmetict.png",
              // poster:"https://cdn.meidaojia.com/mdjwebImages/image/%E6%A0%B8%E5%BF%83%E6%8A%80%E6%9C%AF/%E5%9B%BE%E5%83%8F/cosmetict.png",
              path:"https://cdn.meidaojia.com/mdjwebImages/video/pic_cosmetict.mp4",
              id: 3,
              dec: "在线虚拟试戴美瞳镜片并搭配不同场景妆容",
              isxian: 0,
            },
            {
              name: "珠宝饰品",
              poster:"https://cdn.meidaojia.com/mdjwebImages/image/Images-newmdj/ornament.jpg",
              // path:
              //   "https://cdn-mdj.oss-cn-beijing.aliyuncs.com/mdjwebImages/image/%E6%A0%B8%E5%BF%83%E6%8A%80%E6%9C%AF/%E5%9B%BE%E5%83%8F/ornament.png",
              // poster:"https://cdn.meidaojia.com/mdjwebImages/image/%E6%A0%B8%E5%BF%83%E6%8A%80%E6%9C%AF/%E5%9B%BE%E5%83%8F/ornament.png",
              path:"https://cdn.meidaojia.com/mdjwebImages/video/pic_ornament.mp4",
              id: 4,
              dec: "珠宝饰品实际佩戴效果展示",
              isxian: 0,
            },
            {
              name: "美甲",
              poster:"https://cdn.meidaojia.com/mdjwebImages/image/Images-newmdj/manicure.jpg",
              // path:
              //   "https://cdn-mdj.oss-cn-beijing.aliyuncs.com/mdjwebImages/image/%E6%A0%B8%E5%BF%83%E6%8A%80%E6%9C%AF/%E5%9B%BE%E5%83%8F/manicure.png",
              // poster:"https://cdn.meidaojia.com/mdjwebImages/image/%E6%A0%B8%E5%BF%83%E6%8A%80%E6%9C%AF/%E5%9B%BE%E5%83%8F/manicures.png",
              path:"https://cdn.meidaojia.com/mdjwebImages/video/pic_manicure.mp4",
              id: 5,
              dec: "指甲油，美甲造型，随心试",
              isxian: 0,
            },
          ],
        },
      ],
    };
  },
  components: {
    NavTiltle,
    tabCard,
  },
  methods: {
     windowScroll() {
         // 滚动条距离页面顶部的距离
         // 以下写法原生兼容
         let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
          // console.log(scrollTop);
          if(scrollTop>0&&scrollTop<200){
            document.getElementById('myVideo').play();//开始播放
             this.posFlag=true
          }
          //

      },
    handleClick(){
      console.log('点击tab')
     this.posFlag=true
    },
    autoPlayVideo(){
      console.log('autoPlayVideo')
      this.videoInBrowserHandler();
      document.body.addEventListener('touchstart', this.videoInBrowserHandler);
      this.videoInWeixinHandler();
      document.addEventListener('DOMContentLoaded', this.videoInWeixinHandler);
    },
    videoInBrowserHandler(){
      	/* 自动播放视频效果，解决浏览器或  者APP自动播放问题 */
        console.log('touchstart---999')

      this.videoPlayp5(true);
      document.body.removeEventListener('touchstart', this.videoInBrowserHandler);
      console.log('videoInBrowserHandler')
    },
    videoInWeixinHandler(){
      	/* 自动播放视频效果，解决微信自动播放问题 */
      console.log('videoInWeixinHandler')
      this.videoPlayp5(true);
      document.addEventListener("WeixinJSBridgeReady", function () {
        // this.videoPlay(true);
        pcVideo.play()
      }, false);
      document.removeEventListener('DOMContentLoaded', this.videoInWeixinHandler);
    },
    videoPlayp5(isPlay){
      var media = document.getElementById('pcVideo');
      console.log(media,'222')
      if (isPlay && media.paused) {
      	media.play();
        // alert(22222)
        document.getElementById('myVideo').play();//开始播放
      }
      if (!isPlay && !media.paused) {
      	media.pause();
        // alert(11111)
        document.getElementById('myVideo').pause();//开始播放
      }
    },
    clickFn(ind) {
      console.log(ind);
    },
    posCKI(inds){
      console.log('dianji==!')
      this.$refs.videoPlayMoblie.forEach((item,ind)=>{

        // item.pause()

        if(ind==inds){
          this.$refs.videoPlayMoblie[inds].play()
          this.posFlag=false
        }
      })

      // document.getElementById('myVideo').pause();//开始播放
    },
    dianji(items, indexs, inde) {
      // console.log(this.$refs.videoPlayMoblie[indexs],'Hispanic')
      this.posFlag=true
      // console.log()
      // this.$refs.videoPlayMoblie.forEach((item,ind)=>{
      //   console.log(item.paused,'视频')
      //   item.pause()
      //    console.log(item.paused,'视频2')
      //   if(ind==indexs){
      //     this.$refs.videoPlayMoblie[indexs].play()
      //   }
      // })
      // this.$refs.videoPlayMoblie[indexs].setAttribute("controls", "controls");
      // this.dianji(items, indexs, inde)
      // this.posFlag=false
      // e.currentTarget.parentElement.previousElementSibling.firstElementChild.setAttribute("controls", "controls");
      // setTimeout(()=>{},3000)
      // e.currentTarget.parentElement.previousElementSibling.firstElementChild.play();//小视频播放
// console.log(e.currentTarget.parentElement.previousElementSibling.firstElementChild,'你当前点击的元素')
 // setTimeout(()=>{
 //   console.log(e.path[3].children[0].firstElementChild,'你当前点击的元素')
 //          // document.getElementById('moblieVideo').play();//
 //          // e.path[3].children[0].firstElementChild&&e.path[3].children[0].firstElementChild.play()
 //                 },10)
//        document.body.addEventListener('touchstart',function () {
//          console.log('开始触摸')
//        setTimeout(()=>{
//          document.getElementById('myVideo').play();//开始播放
// // document.getElementById('pcVideo').play();
//        },10)

//       },false);
       // document.getElementById('myVideo').play();//开始播放
      // setInterval(()=>{
      //   document.getElementById('myVideo').play();//开始播放
      // },5000)
      //设置 img 属性，如 id
      // 　　　　img.setAttribute("id", "newImg");
      // controls="controls"
      // document.getElementById('myVideo').setAttribute("controls", "controls");
 //       console.log( document.getElementById('pcVideo').paused,'tapbar',document.getElementById('myVideo').paused)
 //      if(document.getElementById('myVideo').paused){
 // alert(3333)
 //        // setTimeout(()=>{
 //        //   document.getElementById('myVideo').play();//开始播放
 //        // },0)
 //      }else{
 //         alert(111)
 //      }
      console.log(items, indexs, inde);
      // setTimeout(()=>{this.dianji(items, indexs, inde)
      // console.log('chengg')},100)
      this.techAdvances[indexs].nameList.forEach((item, index) => {
        console.log(item);
        item.isxian = "0";
        if (inde == index) {
          item.isxian = "1";
          this.imgs = item.path;
          this.techAdvances[indexs].path = item.path;
          // this.imgs = item.path;
          this.techAdvances[indexs].poster = item.poster;

           // localStorage.setItem("videoValue",true)
          // this.autoPlayVideo()
          // document.getElementById('moblieVideo').src=item.path;
          // console.log(document.getElementById('moblieVideo'),'点击快速播放',this.$refs['videoPlayMoblie'].[1])
          // setTimeout(()=>{
          // document.getElementById('moblieVideo').play();// 小视频播放
          //        },10)
        }
      });
    },
    quehuan(inde) {
      console.log(inde);
      this.techAdvances.forEach((item, index) => {
        item.isxains = "0";
        if (this.techAdvances[inde].isxains == "0") {
          this.techAdvances[inde].isxains = "1";
        }
      });
      this.techAdvances[inde].nameList.forEach((ite, ind) => {
        if (ite.isxian == "1") {
          this.imgs = ite.path;
        }
      });
    },
  },
 beforeDestroy() {
      window.removeEventListener('scroll', this.windowScroll)
  },
  mounted() {
    this.posFlag=true
    // this.dianji({}, 0, 0)
    // this.autoPlayVideo()
    window.addEventListener('scroll', this.windowScroll)

    // document.body.addEventListener('touchstart',function () {
    //          // console.log( document.getElementById('moblieVideo'),'hhscudchwdieuhc')
    //        setTimeout(()=>{
    //          document.getElementById('myVideo').play();//开始播放
    // // document.getElementById('pcVideo').play();
    //        },10)
    //       },false);
  },
};
</script>
<style lang="less" scoped>
.Pannel5 {
  padding-bottom: 10%;
  width: 100%;
  height: 100%;
  background: #f5f2f5;
  .moblie-conent {
    display: none;
  }
  .pc-conent {
    width: 75%;
    // height: 100vh;
    height: 866px;
    background: #f5f2f5;
    display: flex;
    box-sizing: border-box;
    margin: 0 auto;
    margin-bottom: 20px;
    // padding: 0 11.25rem;
    //  padding: 0 10% 0;
    .tap {
      width: 50%;
      height: 100%;
      transition: all 0.8s ease 0s;
      .left {
        width: 100%;
        height: 100%;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .right {
        width: 100%;
        height: 100%;

        .title {
          width: 100%;
          height: 100%;
          display: flex;
          .title-left {
            width: 60%;
            // height: 39rem;
            position: relative;
            /deep/ .block{
               position: absolute;background: aliceblue;height: 100%; width: 100%;
               .el-image{
                 position: absolute;
                     width: 100px;
                     height: 100px;
                     top: 50%;
                     transform: translate(-50%);
                     left: 50%;
               }
            }
            .mengc {
              width: 100%;
              height: 100%;
              display: block;
              position: absolute;
              top: 0;
              left: 0;

              background: linear-gradient(
                180deg,
                rgba(98, 11, 47, 0.15) 0%,
                rgba(0, 0, 0, 0.1) 100%
              );
              box-shadow: 15px 20px 40px 0px rgba(44, 0, 27, 0.2);

              .text-num {
                width: 11.25rem;
                height: auto;
                text-align: center;
                position: absolute;
                bottom: 10%;
                left: 50%;
                color: #fff;
                transform: translate(-50%, -10%);
                span {
                  font-size: 30px;
                  font-weight: 500;
                }
                p {
                  font-size: 25px;
                  font-weight: 400;
                }
              }
            }
            img {
              width: 100%;
              height: 100%;
            }
          }
          .title-right {
            width: 35%;
            display: flex;
            height: 100%;
            flex-direction: column;
            .rights {
              width: 100%;
              height: 10%;
              font-size: 16px;
              margin-bottom: 10%;
              transition: all 0.2s ease 0s;
              .right-shang {
                display: flex;
                height: 100%;
                .gang {
                  width: 10px;
                  height: 100%;
                  // background: #ee0090;
                  background: linear-gradient(
                    138deg,
                    #ee0090 0%,
                    #e84142 100%,
                    #e84142 100%
                  );
                }
                .zi {
                  width: 100%;
                  // background: linear-gradient(90deg, #EE0090 0%, rgba(232, 65, 66, 0) 100%, #E84142 100%);
                  background: linear-gradient(
                    90deg,
                    rgba(238, 0, 144, 0.1) 10%,
                    rgba(232, 65, 66, 0) 100%,
                    rgba(232, 65, 66, 0.1) 10%
                  );
                  // opacity: 0.1;

                  //   background: linear-gradient(
                  //     90deg,
                  //     #ee0090 0%,
                  //     rgba(232, 65, 66, 0) 100%,
                  //     #e84142 100%
                  //   );
                  // background: rgba(232, 65, 66, 0.1);
                  overflow: hidden;
                  height: 100%;
                  position: relative;
                  span {
                    position: absolute;
                    top: 50%;
                    transform: translate(0, -50%);
                    left: 10px;
                    display: block;
                    font-size: 0.8rem;
                  }
                }
              }
            }
            .rights1 {
              width: 100%;
              height: 35%;
              margin-bottom: 10%;
              // background: rgba(232, 65, 66, 0.1);
              // background:rgba('#F009E','#FD4F58');
              background: linear-gradient(
                138deg,
                #ee0090 0%,
                #e84142 100%,
                #e84142 100%
              );
              opacity: 0.8;
              color: #fff;
              transition: all 0.2s ease 0s;
              .right-shang {
                display: flex;
                .gang {
                  width: 10px;
                  height: 70px;
                  background: #e84142;
                }
                .zi {
                  margin-top: 5%;
                  margin-bottom: 5%;
                  span {
                    margin-left: 10px;
                    font-size: 1rem;
                  }
                }
              }
              .right-xia {
                width: 92%;
                margin: 0 auto;
                font-size: 0.8rem;
                margin-left: 10px;
              }
            }
          }
        }
      }
    }
    .tap1 {
      width: 25%;
      transition: all 0.8s ease 0s;
      .left {
        width: 100%;
        height: 100%;
        position: relative;
        .mengc1 {
          width: 100%;
          height: 100%;
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          background: linear-gradient(
            180deg,
            rgba(114, 0, 47, 0.42) 0%,
            rgba(0, 0, 0, 0.7) 100%
          );
          .text-num {
            width: 11.25rem;
            height: auto;
            text-align: center;
            position: absolute;
            bottom: 10%;
            left: 50%;
            color: #fff;
            transform: translate(-50%, -10%);
            opacity: 0.5;
            span {
              font-size: 30px;
              font-weight: 500;
            }
            p {
              font-size: 25px;
              font-weight: 400;
            }
          }
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}

@media screen and (max-width: 769px) {
  .Pannel5 {
    width: 100%;
    height: 100%;
    padding-bottom: 10%;
    background: #f5f2f5;
    .pc-conent {
      display: none;
    }
    .moblie-conent {
      display: block;
      width: 100%;
      height: 100%;
      background: #f5f2f5;
      display: flex;
      box-sizing: border-box;
      padding: 0 30px 0;
      /deep/ .el-tabs {
        width: 100%;
      }
      /deep/ .el-tabs__nav-wrap::after {
        background: #f5f2f5;
      }
      /deep/ .el-tabs__nav .is-top {
        border-bottom: none;
      }
      /deep/ .el-tabs__nav {
        width: 100%;
        height: 100%;
        .el-tabs__active-bar {
          opacity: 0;
        }
        .el-tabs__item {
          width: 30%;
          text-align: center;
          background: rgba(232, 65, 66, 0.1);
          border-radius: 20px;
          margin: 0 5px;
          padding: 0;
          letter-spacing: 2px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          opacity: 0.5;
        }
        .el-tabs__item.is-active {
          color: #ffffff;
          background: linear-gradient(
            138deg,
            #ee0090 0%,
            #e84142 100%,
            #e84142 100%
          );
          border-radius: 83px;
          opacity: 0.8;

          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 600;

          letter-spacing: 2px;

          box-shadow: 3px 9px 16px 0px rgba(232, 65, 66, 0.5);
          // filter: blur(7px);
        }
      }
      .right {
        width: 100%;
        // height: 566px;
        // height: 364px;
        height: 100%;
        .title {
          width: 100%;
          height: 100%;
          display: flex;
          font-size: 26px;
          .title-left {
            // width: 167px;
            flex: 1;
            // width: 60%;
            // height: 39rem;
              // height: 364px;//占位图专用
              height: 364px;
            position: relative;
              /deep/ .el-image{
              width: 100%;
              height: 100%;
              /deep/ .image-slot{
                 width: 100%;
                height: 100%;
                position: relative;
                .errimg{
                  width: 50px !important;
                    height: 50px !important;
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%);

                }
              }
              .el-image__inner{
                 width: 100%;
                height: 100%;

              }
             }
            .mengc {
              width: 100%;
              height: 100%;
              display: block;
              position: absolute;
              top: 0;
              left: 0;
              background: linear-gradient(
                180deg,
                rgba(98, 11, 47, 0.15) 0%,
                rgba(0, 0, 0, 0.1) 100%
              );
              box-shadow: 15px 20px 40px 0px rgba(44, 0, 27, 0.2);
              // background: linear-gradient(180deg, rgba(98, 11, 47, 0.15) 0%, rgba(0, 0, 0, 0.7) 100%);
              // box-shadow: 15px 20px 40px 0px rgba(44, 0, 27, 0.4);
              // opacity: 0.5;
              .text-num {
                width: 11.25rem;
                height: auto;
                text-align: center;
                position: absolute;
                bottom: 10%;
                left: 50%;
                color: #fff;
                transform: translate(-50%, -10%);
                z-index: 9;
                span {
                  font-size: 15px;
                  font-weight: 500;
                }
                p {
                  font-size: 12px;
                }
              }
            }

          // img{ width: 50px;
          //           height: 50px;
          //         position: absolute;
          //         top: 50%;
          //         left: 50%;
          //         transform: translate(-50%);}
          .videopostar{
             width: 100%; height: 364px;
             height: 100%;
             position: relative;//层级
                 z-index: 9;
          }
          .posImg{
            width: 100%; height: 364px;
             height: 100%;
            position: absolute;
                left: 0;
                // display: none;
                 // z-index: 9;
          }
          .spImg{
            width:80px;
            height:80px;
            background: url(../assets/images/核心技术/videoPlay.png) center center;
            background-size: 100%;
            // border-top:30px solid transparent;
            // border-bottom:30px solid transparent;
            // border-left:45px solid #C7C7CC;
            position: absolute;
                top: 50%;
                left: 50%;
                // z-index: 999;
                transform: translate(-50%,-50%);
          }
            // img {
            //   width: 100%;
            //   // height: 100%;
            //   height: 364px;
            // }
          }
          .title-right {
            flex: 1;
            // width: 169px;
            // width: 40%;
            overflow: scroll;
            display: flex;
            // height: 100%;
            height: 364px;
            flex-direction: column;
            .rights {
              width: 100%;
              // height: 10%; //去掉百分比ipda不支持-未展开状态
              height: auto;
              font-size: 16px;
              margin-bottom: 10%;
              transition: all 0.2s ease 0s;
              .right-shang {
                width: 100%;
                height: 100%;
                display: flex;
                background: linear-gradient(
                  90deg,
                  rgba(238, 0, 144, 0.1) 10%,
                  rgba(232, 65, 66, 0) 100%,
                  rgba(232, 65, 66, 0.1) 10%
                );
                // background: linear-gradient(90deg, #E2C8D6 0%, rgba(232, 65, 66, 0) 100%, #F6F2F5 100%);
                // background: linear-gradient(90deg, #E2C8D6 0%, rgba(232, 65, 66, 0) 99%, #F6F2F5 35%);
                .gang {
                  width: 10px;
                  // height: 64px;//调字的未点击状态
                  background: linear-gradient(
                    138deg,
                    #ee0090 0%,
                    #e84142 100%,
                    #e84142 100%
                  );
                  box-sizing: border-box;
                  padding: 18px 0;
                }
                .zi {
                  // margin-top: 5%;
                  //  margin-bottom: 5%;
                  margin:10px 0;
                  line-height: 20px;
                  span {
                    margin-left: 10px;
                    font-size: 1rem;
                  }
                }
              }
            }

            .rights1 {
              width: 100%;
              // height: 35%; //去掉百分比ipda不支持-展开
              // margin-bottom: 10%;
              margin-bottom: 10px;
              background: linear-gradient(
                138deg,
                #ee0090 0%,
                #e84142 100%,
                #e84142 100%
              );
              opacity: 0.8;
              color: #fff;
              transition: all 0.2s ease 0s;
              padding: 0 0 20px 0;
              .right-shang {
                display: flex;
                .gang {
                  width: 10px;
                  height: 70px;
                  background: #e84142;
                }
                .zi {
                  // margin-top: 5%;
                  // margin-bottom: 5%;
                  span {
                    margin-left: 13px;
                    // font-size: 1rem;
                    font-size: 12px;
                  }
                }
              }
              .right-xia {
                // width: 80%;
                padding-left: 13px;
                margin: 0 auto;
                font-size: 10px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
